export enum ListType {
  Contact = 'Contact',
  Account = 'Account'
}
